<script setup lang="ts">
import { onClickOutside } from '@vueuse/core'
import type { IProps, IEmits } from './career-multiChoiceDropdown.types'

defineProps<IProps>()
const emit = defineEmits<IEmits>()

const onChange = (e: Event) => {
  emit('input', (e.target as HTMLInputElement).value)
}

const isOpen = ref<boolean>(false)
const container = ref<HTMLElement | null>(null)

onClickOutside(container, () => {
  isOpen.value = false
})

</script>

<template>
  <div
    ref="container"
    class="field_select--multiple"
  >
    <div
      :class="[
        'input',
        'field_select',
        'multiple',
        {'field_select--expand' : isOpen}
      ]"
    >
      <label
        v-if="label"
        class="label--selected"
        @click="isOpen = !isOpen"
      >
        {{ label }}
      </label>

      <label
        v-else
        class="label--selected"
        @click="isOpen = !isOpen"
      >
        Wybierz
      </label>

      <div class="options">
        <div
          v-for="option in options"
          :key="option.key"
        >
          <div class="label-option">
            <label :for="option.label">
              <input
                :id="option.label"
                type="checkbox"
                :value="option.label"
                :checked="option.key ? modelValue.includes(option.label) : modelValue.length === options.length - 1"
                @change="onChange"
              >
              {{ option.header }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.field {
  .label {
    display: inline-block;
    margin-bottom: 0.4rem;
    margin-left: 0.4rem;
    color: #696676;
    font-size: 1.4rem;
    line-height: 2rem;
  }

  .input {
    position: relative;
    width: 100%;
    max-height: 4.8rem;
    height: 4.8rem;
    background-color: #ffffff;
    border: 0.1rem solid #d0dbda;
    border-radius: 1.6rem;

    input {
      width: 100%;
      height: 100%;
      padding: 1.2rem 1.6rem;
      font-weight: 400;
      font-size: 1.6rem;
      line-height: 2.4rem;
    }
  }

  &_select {
    @include atS {
      max-width: 30rem;
    }

    &.multiple {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin-bottom: 0;
      padding: 1.2rem 0 1.6rem;
      overflow: hidden;
      overflow: clip;

      .options {
        z-index: 2;
        padding: 1.6rem 1.6rem 0.6rem;
        background: white;
        border: 0.1rem solid #d0dbda;
        border-radius: 1.6rem;

        .label-option {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          label {
            width: 100%;
          }
        }
      }

      label {
        position: relative;
        display: flex;
        align-items: center;
        margin: 0 0 1rem;
        padding: 0;
        color: $text-400;
        font-weight: 500;
        font-size: 1.6rem;
        line-height: 2.4rem;
        background-color: #ffffff;
        cursor: pointer;

        &.option {
          padding-left: 1rem;
        }

        &.label--selected {
          padding: 0 1.6rem;
        }

        input {
          min-width: 2.4rem;
          width: 2.4rem;
          height: 2.4rem;
          margin-right: 0.8rem;
          padding: 0;
          border: 0.1rem solid $text-400;
          border-radius: 0.4rem;

          &:checked {
            background-image: url('/icons/icon_check.svg');
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
    }

    &:after {
      position: absolute;
      top: 1rem;
      right: 1rem;
      display: inline-block;
      width: 2.4rem;
      height: 2.4rem;
      margin-left: 0.8rem;
      background-image: url('/icons/icon_arrow_down.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      content: '';
    }

    &--expand {
      max-height: 100%;
      height: 100%;

      &.multiple {
        overflow: visible;
      }
    }
  }

  .select {
    width: 100%;
    height: 100%;
    padding: 0.8rem 1.6rem;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.4rem;
    appearance:none;

    &:after {
      position: absolute;
      top: 1rem;
      right: 1rem;
      display: inline-block;
      width: 2.4rem;
      height: 2.4rem;
      margin-left: 0.8rem;
      background-image: url('/icons/icon_arrow_down.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      content: '';
    }
  }
}
</style>
